import type {SystemStyleObjectRecord} from '@chakra-ui/react';
import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';
import {useStyleConfig} from '@chakra-ui/system';
import type {Size} from 'chakra-react-select';
import {deepmerge} from 'deepmerge-ts';

import {inputTheme} from './Input';

const baseStyle = defineStyle({
  ...inputTheme.baseStyle?.field,
  lineHeight: `short`,
  verticalAlign: `top`,
  minH: `unset`,
  overflow: `hidden`,
  w: `100%`,
  resize: `none`,
});

const variants = {
  outline: defineStyle(props => inputTheme.variants?.outline(props).field ?? {}),
};

const mergeInputSizes = (inputSizes?: Partial<Record<Size, SystemStyleObjectRecord>>) =>
  deepmerge(inputSizes, {
    xs: {height: `initial`},
    sm: {height: `initial`},
    md: {height: `initial`},
    lg: {height: `initial`, fontSize: `md`},
  });

export const autoSizeTextareaTheme = defineStyleConfig({
  baseStyle,
  sizes: mergeInputSizes(inputTheme.sizes),
  variants,
  defaultProps: inputTheme.defaultProps,
});

export const useAutoSizeTextareaStyleConfig = (props?: Parameters<typeof useStyleConfig>[1]) => {
  return useStyleConfig(`AutoSizeTextarea`, props ?? {});
};
